import React from 'react';
import firebase from 'firebase/app';
import "firebase/analytics";

import './App.css';

import Header from './components/Header';
import Main from './components/Main';
import Footer from './components/Footer';

// Initialise Google Firebase Analytics
firebase.initializeApp({
  apiKey: "AIzaSyDNkHSNaZCMXVA-7kjABwtya2sdI4vj1_g",
  authDomain: "innovation-rocks-2b8ac.firebaseapp.com",
  databaseURL: "https://innovation-rocks-2b8ac.firebaseio.com",
  projectId: "innovation-rocks-2b8ac",
  storageBucket: "innovation-rocks-2b8ac.appspot.com",
  messagingSenderId: "463324817621",
  appId: "1:463324817621:web:f36786eb2606068bb91a5c",
  measurementId: "G-JK7T3HBS73"
});
firebase.analytics();

function App() {
  return (
    <div className="App">
      <Header />
      <Main />
      <Footer />
    </div>
  );
}

export default App;
